<!--
 * @Author: Latte
 * @Date: 2022-01-24 09:30:16
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-18 09:11:48
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\productionInfoManagement\index.vue-->
<template>
  <div class="app-container">
    <div align="right" style="margin-right:10px;">
        <el-dropdown>
            <span class="el-dropdown-link">
            <i class="el-icon-s-operation"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="drawer = true">资料分类管理</el-dropdown-item>
                <el-dropdown-item @click.native="goToManageFileType()">资料类型管理(旧版)</el-dropdown-item>
                <el-dropdown-item @click.native="drawerEditFileCategory = true">资料类型管理(新版开发中)</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
    <el-drawer
              :visible.sync="drawerEditFileCategory"
              :direction="direction"
              :before-close="handleClose"
              style="overflow: auto;"
              size="50%">
        <div align="center" style="margin-top: -40px"><h3>产品资料访问权限管理</h3></div>
        <div style="margin-left:30px;margin-right:30px">
            <p>选择角色</p>
            <p style="line-height:2em;color: gray"><i class="el-icon-warning-outline" style="color: red"></i>若此处找不到所需的资源访问角色，请联系系统管理员。 <el-button type="primary" style="float: right;"  size="medium" @click="openAddUserRoleDialog()">新增产品资料访问角色</el-button></p>
            <el-table
                    :data="csRoleList"
                    style="width: 100%;overflow: auto;"
                    max-height="250px"
                    highlight-current-row
                    @row-click="rowClick">
                <el-table-column
                        prop="roleName"
                        align="center"
                        label="角色">
                </el-table-column>
                <el-table-column label="文档权限" align="center">
                    <template slot-scope="scope">
                        {{getPriority(scope.row.priorityInCs)}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-delete" style="color: red" type="text"  @click="deleteUserRole(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="margin-left:30px;margin-right:30px;margin-top: 20px">
            <p>设置角色权限</p>
            <p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>不同的角色针对不同的资料类型有不同的访问权限。在<a style="color: blue">上表选定角色</a>后，在此处为角色分配各种资料类型的访问权限 </p>
            <p>角色名称：<b>{{chooseRoleName}}</b><el-button type="primary" style="float: right" size="medium">新增资料类型</el-button></p>
            <el-table
                    :data="fileCategoryList"
                    style="width: 100%;overflow: auto;"
                    max-height="250px">
                <el-table-column
                        prop="typeName"
                        align="center"
                        label="资料类型">
                </el-table-column>
                <el-table-column
                        prop="read"
                        align="center"
                        label="浏览">
                    <el-checkbox></el-checkbox>
                </el-table-column>
                <el-table-column
                        prop="download"
                        align="center"
                        label="下载">
                    <el-checkbox></el-checkbox>
                </el-table-column>
            </el-table>
        </div>
    </el-drawer>
    <el-drawer
              :visible.sync="drawer"
              :direction="direction"
              :before-close="handleClose"
              style="overflow: auto;"
              size="50%">
        <div align="center" style="margin-top: -40px"><h3>产品资料分类管理</h3></div>
        <div style="margin-left:30px;margin-right:30px">
            <p>分类目录</p>
            <p style="line-height:2em;color: gray"><i class="el-icon-warning-outline" style="color: red"></i>产品资料按分类类别进行管理，上传产品资料时需要选择资料所属的分类类别 <el-button type="primary" style="float: right;" @click="handleClickAddClassification()" size="small">增加分类</el-button></p>
            <el-table
                    :data="tagsList"
                    style="width: 100%;overflow: auto;"
                    max-height="250px">
                <el-table-column
                        prop="showName"
                        align="center"
                        label="分类名称">
                </el-table-column>
                <el-table-column
                        prop="sort"
                        align="center"
                        label="排序序号">
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        label="操作">
                    <el-button icon="el-icon-edit" style="color: #0ea432" type="text">编辑</el-button>
                    <el-button icon="el-icon-delete" style="color: red" type="text">删除</el-button>
                </el-table-column>
            </el-table>
        </div>
        <div style="margin-left:30px;margin-right:30px;margin-top: 20px">
            <p>设置分类属性<el-button type="primary" style="float: right" size="small">属性设置</el-button></p>
            <p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>为分类设置属性后，分类内的所有产品资料自动拥有这些属性。上传资料时，资料的属性值将从下面配置的属性值中选择。若要修改属性及属性值，请前往<a style="color: blue">属性设置</a>页面进行设置 </p>
            <el-table
                    :data="addPropertyList"
                    style="width: 100%;"
                    max-height="300px">
                <el-table-column
                        prop="isEnable"
                        align="center"
                        width="50px">
                    <el-checkbox></el-checkbox>
                </el-table-column>
                <el-table-column
                        prop="name"
                        align="center"
                        label="属性名称">
                </el-table-column>
                <el-table-column
                        prop="name"
                        align="center"
                        label="属性值">
                    <template slot-scope="scope">
                        <p>
                            <el-tag
                                    type="primary"
                                    size="small"
                                    v-for="item in scope.row.value"
                                    :key="item.value"
                                    style="margin-right: 10px; margin-bottom: 10px"
                            >
                                {{ item.propName}}
                            </el-tag>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        label="操作">
                    <el-button icon="el-icon-edit" style="color: blue" type="text">设置属性值</el-button>
                </el-table-column>
            </el-table>
            <el-form-item >
                <el-button>保存</el-button>
                <el-button>退出</el-button>
            </el-form-item>
        </div>
    </el-drawer>

    <el-tabs v-model="activeName" @tab-click="handleClick()" v-tab-change:activeName="setActiveName">
      <el-tab-pane label="全部"  name="-1"></el-tab-pane>
      <el-tab-pane
              v-for="item of tagsList"
              :label="item.showName"
              :name="item.fieldValue.toString()"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="toolbar" >
      <div>
        <el-input v-model="listQuery.keyword" placeholder="资料名称/资料描述/作者名称" size="small" style="width:436px;margin-top:3px;" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px;margin-top:3px;" icon="el-icon-search" @click="handleSearchList()" >搜索</el-button>
      </div>
      <div align="right"><el-button type="primary" style="width:140px" size="medium" @click="goToUploadFile()" align="right">上传新资料</el-button></div>
    </div>
      <div class="toolbar">
        <div>
          <el-form
                  :model="listQuery"
                  size="small"
                  label-width="150px"
                  :inline="true"
                  v-if="showSelectionClass!==false"
          >
            <el-select
                    v-model="listQuery.condition"
                    value-key="csFileConditionID"
                    placeholder="请选择筛选条件"
                    style="width: 210px"
                    size="small"
                    @change="onConditionChange($event)"
                    clearable
            >
              <el-option
                      v-for="item in conditionOptions"
                      :key="item.csFileConditionID"
                      :label="item.showName"
                      :value="item"
              ></el-option>
            </el-select>
            <i class="el-icon-right" style="margin-left: 5px;" ></i>
            <el-select
                    v-model="listQuery.conditionVal"
                    @change="onConditionValueChange($event)"
                    placeholder="请选择筛选值"
                    style="margin-left: 5px;width: 200px"
                    size="small"
                    clearable
            >
              <el-option
                      v-for="item in conditionValOptions"
                      :key="item.csFileConditionID"
                      :label="item.showName"
                      :value="item"
              ></el-option>
            </el-select>
<!--            <el-select v-model="listQuery.fileType" placeholder="文件格式" class="tag-select-type" size="small" style="margin-left: 10px;width: 100px" clearable @change="onFileTypeChange($event)">-->
<!--              <el-option v-for="item in fileTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--            </el-select>-->
            <el-button type="primary" size="small" style="margin-left: 10px;" icon="el-icon-refresh-left" @click="handleResetSearch()" >重置</el-button>
          </el-form>
        </div>
        <div align="right">
          <el-button size="medium" style="margin-left:  10px;margin-top:3px;width:140px" @click.stop="$router.push('tagManagement')">属性设置</el-button>
        </div>
      </div>

      <!-- 角色权限展示对话框 -->
      <el-dialog title="角色权限" :visible.sync="roleListDialog" width="60%">
        <h4>温馨提示：1.角色权限与“资料类型”属性关联；2.在新增/编辑产品资料时，需配置“资料类型”参数，“产品资料”才能间接绑定角色访问权限</h4>
        <el-table :data="accessList" style="width: 100%">
          <el-table-column prop="roleName" label="角色名称" align="center">
          </el-table-column>
          <el-table-column prop="readAccess" label="读权限" align="center">
          </el-table-column>
          <el-table-column  prop="downloadAccess" label="下载权限" align="center">
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 设备系列对话框 -->
      <el-dialog title="仪器" :visible.sync="seriesListDialog" width="60%">
        <el-table :data="seriesList" style="width: 100%">
          <el-table-column
                  prop="number"
                  label="编号"
                  align="center"
          ></el-table-column>
          <el-table-column prop="seriesName" label="仪器系列名" align="center">
          </el-table-column>
          <el-table-column prop="model" label="仪器型号" align="center">
          </el-table-column>
          <el-table-column prop="version" label="仪器版本号" align="center">
          </el-table-column>
        </el-table>
      </el-dialog>

        <el-table :data="fileList" stripe border :header-cell-style="{ background: '#F5F7FA' }" :cell-style="changeCellStyleExpand" style="width: 100%; margin-bottom: 20px">
          <el-table-column label="属性" type="expand" width="70">
            <template slot-scope="scope">
              <el-form
                      label-position="left"
                      inline
                      class="demo-table-expand"
                      v-if="scope.row.csFileParams"
              >
                <el-row>
                  <el-col :span="8">
                      <el-form-item label="文件所属范畴">
                      <span>{{
                        scope.row.csFileParams.dataType === 0
                          ? "超声"
                          : dataType === 1
                          ? "X-Ray"
                          : "I-Bus"
                      }}</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="作用领域">
                      <span>{{
                        scope.row.csFileParams.areaType === 0 ? "医用" : "兽用"
                      }}</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="控制面板">
                      <span>{{
                        scope.row.csFileParams.controlPanel === 0
                          ? "位置"
                          : scope.row.csFileParams.controlPanel === 1
                          ? "触摸"
                          : "按键"
                      }}</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="部件">
                      <span>{{
                        scope.row.csFileParams.parts === 0
                          ? "其它"
                          : scope.row.csFileParams.parts === 1
                          ? "整套"
                          : scope.row.csFileParams.parts === 2
                          ? "机头"
                          : "机架"
                      }}</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="功率值">
                        <span>{{ scope.row.csFileParams.power }}KW</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="限束器">
                      <span>{{
                        scope.row.csFileParams.speedGovernor === 0
                          ? "未知"
                          : scope.row.csFileParams.speedGovernor === 1
                          ? "旋转"
                          : "不旋转"
                      }}</span>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="资料描述">
                      <span>{{scope.row.fileDesc}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <span v-else>暂无数据</span>
            </template>
          </el-table-column>
          <el-table-column label="ID" align="center" prop="csFileID" width="70"></el-table-column>
          <el-table-column label="产品资料名称" align="center" prop="fileShowName" width="160">
            <template slot-scope="scope">
            <el-popover
                  placement="top-start"
                  trigger="hover"
                  :disabled="scope.row.fileShowName.length <= 10">
            <div>{{ scope.row.fileShowName }}</div>
            <span slot="reference" v-if="scope.row.fileShowName.length <= 10">{{scope.row.fileShowName}}</span>
            <span slot="reference" v-if="scope.row.fileShowName.length > 10">{{scope.row.fileShowName.substr(0, 10) + "..."}}</span>
            </el-popover></template>
          </el-table-column>
          <el-table-column label="上传时间" align="center" prop="createTime" width="155" ></el-table-column>
          <el-table-column label="上传者" align="center" prop="nickname" width="100"></el-table-column>
          <el-table-column
                  label="格式" align="center" prop="fileSuffix" width="70"
                  :filters="[
                    { text: '.mp3', value: '.mp3' },
                    { text: '.mp4', value:'.mp4' },
                    { text: '.png', value: '.png' },
                    { text: '.jpg', value: '.jpg' },
                    { text: '.pdf', value: '.pdf' },
            ]"
                  :filter-method="filterFileSuffixHandler">
          </el-table-column>
          <el-table-column label="大小(MB)" align="center" prop="size" width="90">
            <template slot-scope="scope">
              {{ (scope.row.fileSize / 1024).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="访问数" align="center" prop="viewTimes" width="70"></el-table-column>
          <el-table-column label="下载数" align="center" prop="downloadTimes" width="70"> </el-table-column>
          <el-table-column label="访问权限" align="center" width="80">
            <template slot-scope="scope">
              <el-button
                      :disabled="!scope.row.typeList.length"
                      type="info"
                      size="small"
                      title="查看资料所绑定的角色权限"
                      icon="el-icon-tickets"
                      @click.stop="viewFileAccess(scope.row.typeList[0].csFileTypeID)"
              >
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="适用机型" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                      type="primary"
                      size="small"
                      title="点击查看资料所绑定的仪器信息"
                      icon="el-icon-tickets"
                      :disabled="!scope.row.seriesList.length"
                      @click.stop="viewFileSeries(scope.row)"
              >
                {{ scope.row.seriesList.length }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="是否置顶" align="center" width="80">
            <template slot-scope="scope"><el-switch v-model="scope.row.topStatus" :active-value="1" :inactive-value="0"  @change="onTopStatusChange(scope.row.csFileID,$event)"></el-switch></template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-view"     size="small" title="浏览" @click.stop="viewFile(scope.row)"></el-button>
<!--              <el-button type="success" icon="el-icon-download" size="small" title="下载" @click.stop="downloadFile(scope.row)"></el-button>-->
              <el-button type="info"    icon="el-icon-edit"     size="small" title="编辑" @click.stop="goToFileDetail(scope.row)"></el-button>
              <el-button type="danger"  icon="el-icon-delete"   size="small" title="删除" @click="deleteFile(scope.row)" ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="totalCount" :current-page="currentPage" @current-change="currentChange"/>
        </div>

        <!-- 编辑类别对话框 -->
        <el-dialog :visible.sync="categoryDialogVisible" :title="dialogTitle" width="45%">
        <el-form :model="categoryForm" label-width="80px">
          <el-form-item label="分类名称" prop="name">
            <el-input
                    v-model="categoryForm.name"
                    placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="name">
            <el-input-number v-model="categoryForm.order" :min="1" size="small"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="categoryDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="categoryDialogVisible = false">确 定</el-button>
          </span>
      </el-dialog>

      <!-- 新增类别对话框 -->
      <el-dialog
              title="新增产品资料分类"
              :visible.sync="conditionDialogVisible"
      >
        <el-form ref="formRef" :model="conditionModel" label-width="150px">
          <el-form-item label="类别名称" prop="showName" required>
            <el-input
                    v-model="conditionModel.showName"
                    placeholder="请输入名称"
                    style="width:202px"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="enable" required>
            <el-radio-group v-model="conditionModel.isEnable" >
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="排序">
            <el-input-number size="small" v-model="conditionModel.sort" :min="1"></el-input-number>
            <br>温馨提示：排序值决定分类在管理页顶部分类导航的显示顺序。<br>数值越小排序越靠前。
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.stop="cancelAddCondition()">取 消</el-button>
          <el-button type="primary" size="small" @click.stop="addCondition()">确 定</el-button>
        </div>
      </el-dialog>

      <!--浏览PDF文件对话框-->
      <el-dialog
              :visible="showPdf === true"
              :append-to-body="true"
              :modal-append-to-body="true"
              :lock-scroll='true'
              :destroy-on-close='true'
              :close-on-click-modal='false'
              :width="'80%'"
              :before-close="closePreviewClick"
              top="200px"
              center>
        <div v-if="showPdf === true" class="dialog-body-content-base-style"
             style="justify-content: center; align-items: center">
          <embed :src="this.fileUrl" style="width: 100%; height: 650px"/>
        </div>
      </el-dialog>
      <!--浏览 视频/图片/音频/文档 对话框-->
      <el-dialog
              :visible="showDoc === true   || showImg === true || showVideo === true || showMp3 === true"
              :show-close="true"
              :width="'70%'"
              style="margin-top: 10px"
              class="dialog-div-pre-style"
              :before-close="closePreviewClick"
              center>
        <div v-if="showDoc === true" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
          <iframe frameborder="0"
                  :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
                  width='100%'>
          </iframe>
        </div>
        <div v-else-if="showImg === true" class="dialog-body-content-base-style">
          <img :src="this.fileUrl" style="width:100%"/>
        </div>
        <div v-else-if="showVideo === true" align="center" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
          <video :src="this.fileUrl" controls autoplay class="video" width="100%"></video>
        </div>
        <div v-else-if="showMp3 === true" align="center" class="dialog-body-content-base-style">
          <audio :src="this.fileUrl" autoplay="autoplay" controls="controls" ref="audio" style="width: 70%"></audio>
        </div>
        <div align="center" style="margin-top: 10px;font-weight: bold">{{this.filePlayName}}</div>
      </el-dialog>

      <!-- 添加角色 -->
      <el-dialog title="添加角色" :visible.sync="addUserRoleDialog" width="60%">
          <el-form >
              <el-row :gutter="20">
                  <el-col :span="10">
                      <el-form-item
                              label="系统角色名称"
                              :label-width="labelWidth">
                          <el-select
                                  v-model="roleID"
                                  clearable
                                  style="width: 200px"
                          >
                              <el-option
                                      v-for="item in systemRoleList"
                                      :key="item.roleID"
                                      :label="item.roleName"
                                      :value="item.roleID"> </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="14">
                      <el-form-item
                              label="文档访问权限"
                              :label-width="labelWidth">
                          <el-select
                                  v-model="priorityCs"
                                  clearable
                                  style="width: 330px"
                          >
                              <el-option
                                      v-for="item in priorityInCs"
                                      :key="item.value"
                                      :label="item.desc"
                                      :value="item.value"> </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
          </el-form>
          <div slot="footer">
              <el-button size="small" @click="addUserRoleDialog = false">
                  取消
              </el-button>
              <el-button type="primary" size="small" @click="addUserRole()">
                  确认
              </el-button>
          </div>
      </el-dialog>

      <!-- 添加资料类型 -->
      <el-dialog
              title="新增资料类型"
              :visible.sync="addFileCategoryDialog"
              width="40%"
      >
          <el-form :model="addFileCategoryForm">
              <el-form-item label="资料类型名称" :label-width="labelWidth" required>
                  <el-input v-model="addFileCategoryForm.name"></el-input>
              </el-form-item>
              <el-form-item label="资料类型描述" :label-width="labelWidth">
                  <el-input
                          type="textarea"
                          rows="2"
                          v-model="addFileCategoryForm.desc"
                  ></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer">
              <el-button size="small" @click="addFileCategoryDialog = false">
                  取消
              </el-button>
              <el-button type="primary" size="small" @click="addFileCategory()">
                  确认
              </el-button>
          </div>
      </el-dialog>

  </div>
</template>

<script>
var FileSaver = require("file-saver");
import {getConditionList,getConditionDetail,updateCondition,deleteCondition,addCondition} from "@/api/system/CSDocument/file";
import {getFileCategoryList,
        getSeriesList,
        getFileByCondition,
        editFile,
        getCsRoleList,
        getRoleList,
        topStatusFile} from "@/api/system/CSDocument/file";
import {
    getSystemRoleList,
    setCSRole
} from "@/api/system/CSDocument/user";
import {deleteFile, getFileList} from "../../../api/system/CSDocument/file";

//数值比较，用于排序
function sortArr(attr) {
  return function(a,b) {
    return a[attr] - b[attr]
  }
}

export default {
  name: "",
  data() {
    return {
      remainRoleList:[],
      csRoleList:[],
      chooseRoleName: "",
      drawerEditFileCategory: false, //右栏抽屉显示按钮：产品资料类型管理
      drawer: false, //右栏抽屉显示按钮：分类管理
      /*******以下是预览文件配置参数*******/
      //文件路径
      pageCount: undefined, // pdf文件总页数
      filePlayName:"",      //文件完整名称

      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      currentPagePdf: 0,        // pdf文件页码
      /*******以上是预览文件配置参数*******/

      showSelectionClass:false,
      activeName: "-1",
      isSearched: false, // 页面是否处于搜索状态
      // 二级栏目数据
      conditionOptions: [],
      // 三级栏目数据
      conditionValOptions: [],
      // 检索内容
      listQuery: {
        keyword: "", // 搜索框内容
        csFileTypeId: "",
        seriesType: "",
        fileType: "",
        areaType: "",
        category: {}, // 分类
        condition: {}, // 筛选条件
        conditionVal: {}, // 筛选条件的值
      },
      fileList: [],
      pageSize: 10,
      totalCount: 10,
      currentPage: 1,
      categoryDialogVisible: false,
      fileUploadVisible: false,
      dialogTitle: "",
      categoryForm: {
        name: "",
        order: 1,
      },
      fileCategoryData: [],
      //文件类型下拉列表
      fileTypeOptions: [{
        value: '.mp3',
        label: 'mp3'
      }, {
        value: '.mp4',
        label: 'mp4'
      }, {
        value: '.jpg',
        label: 'jpg'
      }, {
        value: '.png',
        label: 'png'
      }, {
        value: '.pdf',
        label: 'pdf'
      }],

      //标签
      dynamicTags: [],
      inputTagVisible: false,
      inputTagValue: '',
      //角色列表
      roleList: [],
      inputRoleList: ['系统管理员'],
      //设备系列列表
      seriesData: [],
      seriesListDialog: false, // 设备系列列表对话框开关
      roleListDialog: false, // 角色权限列表对话框开关
      accessList:[],         // 角色权限弹框内容
      // 作用领域
      areaTypeOptions: Object.freeze([
        { value: 0, label: "医用" },
        { value: 1, label: "兽用" },
      ]),
      tagsList:[],
      labelWidth: "135px",
      conditionDialogVisible: false, // 编辑筛选条件加载开关
      conditionModel: {
        createUserID:"",
        showName:"",
        fieldName:"dataType",
        fieldValue:"",
        fieldOp:"equal",
        isEnable:true,
        userDataType:2,
        sort:"",
      },
      /**
       * fill  1 必填 2 非必填
       * type: 1 有表（无需自定义） 2 无表（需自定义） 3 填空
       * disable:
       */
      addPropertyList:[
        // {typeName:"csFileTypeID",name:"资料类型",fill:"1",type:"1",show:true},
        {typeName:"machineSeriesID",name:"适用机型",fill:"1",type:"2",show:true},
        {typeName:"areaType",name:"应用领域",fill:"2",type:"2",value:[{propName:"医用",value:"0"},{propName:"兽用",value:"1"}],show:true},
        {typeName:"parts",name:"设备部件",fill:"2",type:"2",value:[{propName:"整套",value:"1"},{propName:"机头",value:"2"},{propName:"机架",value:"3"},{propName:"其他",value:"0"}],show:true},
        {typeName:"controlPanel",name:"面板类型",fill:"2",type:"2",value:[{propName:"按键",value:"1"},{propName:"触摸",value:"2"}],show:true},
        {typeName:"power",name:"功率(KW)",fill:"2",type:"3",value:[{propName:"1",value:"1"},{propName:"5",value:"5"},{propName:"10",value:"10"}],show:true},
        {typeName:"speedGovernor",name:"限束器",fill:"2",type:"2",value:[{propName:"旋转",value:"1"},{propName:"不旋转",value:"2"}],show:true},
      ],
      addUserRoleDialog: false, // 添加用户角色对话框开关
      systemRoleList:[],
      userRoleList: [], // 用户角色列表
      roleID:'',
      priorityCs:'',
      priorityInCs:[
            {value:-1,desc:"禁止访问任何文件"},
            {value:0,desc:"可访问公开不需要权限的文件"},
            {value:1,desc:"只允许访问绑定系列下的有权限和公开的文件"},
            {value:2,desc:"访问有权限的文件和公开文件"},
            {value:3,desc:"访问所有的文件"}
      ],
      fileCategoryList: [], // 文件类别列表
      addFileCategoryDialog:false,//新增资料类型对话框，
      addFileCategoryForm:{name:"",desc:""},
      currentRowId:"",//选中某个角色
    };
  },

  computed: {
    formatPermission(data) {
      return function (data) {
        switch (data) {
          case 0:
            return "Ⅰ 类代理商";
          case 1:
            return "Ⅱ 类代理商";
          case 2:
            return "产品用户";
          case 3:
            return "注册用户";
          case 4:
            return "内部员工";
        }
      };
    },
  },

  async created() {
    this.getAllFileCategoryList();
    this.getFileCategoryList(); //获取资源类型
    this.getSeriesList();       //设备系列查询
    this.getFileList();         //列表查询.
    this.searchClassificationList();

    this.getCsRoleList();
    this.getRoleList();
  },


  methods: {
      rowClick(row, event, column){
          console.log(row);
          this.currentRowId = row.id; //选中角色id
          this.chooseRoleName=row.roleName;//选中角色名字
          for (const temp of this.fileCategoryList) {
              if (temp.roleList !== null) {
                  for (const role of temp.roleList) {
                      if (role.roleID === this.currentRowId) {
                          if (1 === role.permissionType) {
                              temp.read = true;
                          } else if (2 === role.permissionType) {
                              temp.downLoad = true;
                          } else {
                              temp.read = false;
                              temp.download = false;
                          }
                          break;
                      }
                  }
              }
          }
          console.log(this.fileCategoryList);
      },
      addFileCategory(){

      },
      /**
       * 获取文件类别列表
       */
      getAllFileCategoryList() {
          let params = {
              sortName: "",
              sortOrder: "asc",
              pageNumber: 1,
              pageSize: 99,
              keyword: "",
              where: "",
          };
          getFileCategoryList(params).then((res) => {
              this.fileCategoryList=[];
              for(const temp of res.data.rows){
                  if (temp.deleteTime === null){
                      this.fileCategoryList.push(temp);
                  }
              }
          });
      },
      /**
       * 添加用户角色
       */
      addUserRole() {
          // 表单验证
          if (!this.roleID) {
              this.$message({
                  message: "系统角色名称不能为空。",
                  type: "warning",
              });
              return;
          }
          if(this.csRoleList!=null){
              for(const temp of this.csRoleList){
                  if(temp.roleID===this.roleID){
                      this.$message({
                          message: "文档角色已存在，请重新选择 系统角色名称",
                          type: "warning",
                      });
                      return;
                  }
              }
          }
          if (!this.priorityCs) {
              this.$message({
                  message: "文档访问权限不能为空。",
                  type: "warning",
              });
              return;
          }
          const data = {
              roleList:[
                  {roleId: this.roleID, priorityInCs: this.priorityCs}],
              workInCs:1
          };
          setCSRole(data).then(() => {
              this.$message({
                  message: "操作成功",
                  type: "success",
              });
              this.addUserRoleDialog = false;
              this.getUserRoleList();
          });
      },
    /**
     * 打开添加用户角色对话框
     */
    openAddUserRoleDialog() {
          // 初始化
          this.roleID='';
          this.priorityCs='';
          this.getSystemRoleList().then((res) => {
              console.log(res);
              this.addUserRoleDialog = true;
          });
    },

      /**
       * 获取系统角色列表
       */
    getSystemRoleList(){
          return new Promise((resolve, reject) => {
              let params = {
                  orderType: "",
                  orderBy: "",
                  pageNumber: this.currentPage,
                  pageSize: 100,
              };
              getSystemRoleList(params).then((res)=>{
                  this.systemRoleList=res.data.result
                  resolve("getSystemRoleList done");
              })
          });

    },

    /**
     * 获取角色权限
     */
    getPriority(value){
          if(value !=null){
              for (const temp of this.priorityInCs){
                  if(temp.value===value){
                      return temp.desc;
                  }
              }
          }
    },

      /**
       * 删除用户角色
       *
       * @param {object} row 选中对象
       */
      deleteUserRole(row) {

          const params = {
              roleList:[
                  {roleId: row.roleID, priorityInCs: row.priorityInCs}],
              workInCs:0
          };
          this.$confirm("您要删除此用户角色吗？", this.$t("tips"), {
              confirmButtonText: this.$t("yes"),
              cancelButtonText: this.$t("no"),
              type: "warning",
          })
              .then(() => {
                  setCSRole(params).then(() => {
                      this.$message({
                          message: "操作成功",
                          type: "success",
                      });
                      this.getRoleList();
                  });
              })
              .catch(() => {
                  this.$message("取消操作");
              });
      },

    getRoleList(){
        let param={
            pageNo:1,
            pageSize:100
        };
        getRoleList(param).then((res)=>{
            this.roleList=res.data.result;
            if(this.roleList!=null){
                for(const temp of this.roleList){

                }

            }
        });
    } ,

    getCsRoleList(){
        let param={
            orderType: "",
            orderBy: "",
            pageNo:1,
            pageSize:100,
        };
        getCsRoleList(param).then((res)=>{
            this.csRoleList=res.data.result
        });
    },

    //分类列表搜索
    searchClassificationList(){
      let param={
        includeChild:1
      };
      getConditionList(param).then((res) => {
        var tempList=[];
        var maxValue=0;
        var maxSort=0;
        if(res.data.length>0){
         for(var temp of res.data){
           if(temp.isEnable===true){
             tempList.push(temp);
           }
           if (temp.fieldValue > maxValue) {
             maxValue = temp.fieldValue;
           }
           if(temp.sort>maxSort){
             maxSort=temp.sort;
           }
         }
        }
        this.tagsList=tempList.sort(sortArr('sort'));
        this.conditionModel.fieldValue=parseInt(maxValue)+1;
        this.conditionModel.sort=parseInt(maxSort)+1;
      });
    },
    //新增分类
    addCondition(){
      let params={}
      params.level=0;
      params.showName=this.conditionModel.showName;
      params.fieldName=this.conditionModel.fieldName;
      params.fieldOp=this.conditionModel.fieldOp;
      params.fieldValue=this.conditionModel.fieldValue;
      params.isEnable=this.conditionModel.enable;
      params.userDataType=this.conditionModel.userDataType;
      params.sort=this.conditionModel.sort;
      params.type=0;
      params.fieldOp='equal';
      if(this.level===0) {
        params.parentID = 0;
      }
      else if(this.level===1) {
        params.parentID = this.chosenTag.csFileConditionID;
      }
      addCondition(params).then((res)=>{
        console.log(res);
        if(res.code===200){
          this.$message({
            message: "操作成功",
            type: "success",
          });
        }
        else if(res.code===403){
          this.$message({
            message: res.message,
            type: "Warning",
          });
        }
        this.conditionDialogVisible = false;
        this.activeName="-1";
        this.searchClassificationList();
      });
    },

    /**
     * 过滤处理
     */
    filterFileSuffixHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    /**
     * 文件删除
     */
    deleteFile(row) {
      let params = {
        csFileID: row.csFileID,
      };
      let tips="您要删除此文件吗？";
      this.$confirm(tips, this.$t("tips"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        type: "warning",
      }).then(() => {
                deleteFile(params).then(() => {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.getFileList();
                });
              });
    },

    /**
     * 预览文件
     */
    viewFile(row){
      this.filePlayName=row.fileName+row.fileSuffix;
      let type = this.iconByType(row);
      this.fileUrl = this.config.RESOURCES+row.downUrl;

      if (type.indexOf("doc") !== -1 || type.indexOf("docx") !== -1 || type.indexOf("xsl") !== -1 || type.indexOf("xslx") !== -1) {
        this.showDoc = true;
      }
      else if (type.indexOf("pdf") !== -1) {
        this.showPdf = true;
      }
      else if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
        this.showImg=true;
      }
      else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
        this.showVideo = true;
      }
      else if (type.indexOf("mp3")!== -1){
        this.showMp3 = true;
      }
      else {
        this.$message("当前文件暂不支持预览")
      }
    },

    /**
     * 经过文件后缀返回文件的图标
     */
    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length)
    },
    closePreviewClick() {
      if (this.showDoc === true) {
        this.showDoc = false;
      } else if (this.showPdf === true) {
        this.showPdf = false;
      } else if (this.showVideo === true) {
        this.showVideo = false;
      } else if (this.showImg === true ){
        this.showImg = false;
      } else if (this.showMp3 === true){
        this.showMp3 = false;
      }
    },

    /**
     * 下载文件
     *
     * @param {object} row 选中对象
     */
    downloadFile(row) {
      console.log(this.config.RESOURCES + row.downUrl);
      FileSaver.saveAs(this.config.RESOURCES + row.downUrl, row.fileName);
      //埋点记录
    },

    /**
     * 跳转到资料详情页
     */
   goToFileDetail(row){
      this.$router.push({
        path: "fileDetail",
        query: {
          row: row,
        },
      });
   },
    /**
     * 查看文件系列
     *
     * @param {object} row 选中对象
     */
    viewFileAccess(row) {
        this.accessList=[];
        if(this.fileCategoryData!==null && row !==null){

          for (var item of this.fileCategoryData){
            if(row === item.csFileTypeID){
              for(var role of item.roleList){
                let roleAccess={
                  roleName:role.roleName,
                  readAccess:(role.permissionType===1||role.permissionType===2)?"√":"×",
                  downloadAccess:role.permissionType===2?"√":"×",
                };
                this.accessList.push(roleAccess);
              }
            }
          }
        }
        this.roleListDialog = true;
    },

    /**
     * 查看文件系列
     *
     * @param {object} row 选中对象
     */
    viewFileSeries(row) {
      this.seriesListDialog = true;
      this.seriesList = row.seriesList;
    },

    /**
     *  处理标签
     */
    handleTagClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showTagInput() {
      this.inputTagVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleTagInputConfirm() {
      let inputValue = this.inputTagValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputTagVisible = false;
      this.inputTagValue = '';
    },

    /**
     * 跳转到资料类型管理
     */
    goToManageFileType(index,row){
      this.$router.push({
        name: "manageFileType",
        params: {
          row: row,
        },
      });
    },

    /**
     * 跳转到资料类型管理
     */
    goToManageMachine(index,row){
      this.$router.push("/systemManagement/CSDocumentManagement/instrument");
    },

    /**
     *  跳转到上传文件页面
     */
    goToUploadFile(index,row){
      this.$router.push({
        name: "uploadFile",
        params: {
          row: row,
        },
      });
    },

    /**
     * 获取资源类型列表
     */
    getFileCategoryList() {
      return new Promise((resolve, reject) => {
        let params = {
          sortName: "",
          sortOrder: "asc",
          pageNumber: 1,
          pageSize: 10,
          keyword: "",
          where: "",
        };
        getFileCategoryList(params).then((res) => {
          this.fileCategoryData = [];
          this.fileCategoryData = res.data.rows;
          console.log("this.fileCategoryData", this.fileCategoryData);
          resolve("getFileCategoryList done");
        });
      });
    },

    /**
     * 顶部tab切换相应
     */
    handleClick() {
      console.log(this.activeName);
      if(this.activeName==='-1'){      //-1用于筛选全部
        this.showSelectionClass=false;
      }
      if(this.activeName!=="-2"){ //-2用户新增分类
        if(this.activeName!=="-1"){
          this.showSelectionClass=true;
        }
        this.listQuery.keyword="";
        if(this.tagsList!=null){
          for(var temp of this.tagsList){
            if(this.activeName===temp.fieldValue){
              this.conditionOptions=temp.childConditionList;
            }
          }
        }
        this.clearQueryCondition();
        this.getFileList();
      }
    },
    /**
     * 顶部栏新增分类
     */
    handleClickAddClassification(){
      this.conditionDialogVisible=true;
    },

    /**
     * 获取设备系列列表
     */
    getSeriesList() {
      return new Promise((resolve, reject) => {
        let params = {
          sortName: "",
          sortOrder: "asc",
          pageNumber: 1,
          // 后台不允许返回所有数据，临时设置pageSize = 99
          pageSize: 199,
          keyword: "",
        };
        getSeriesList(params).then((res) => {
          this.seriesData = [];
          res.data.rows.forEach((i) => {
            let obj = {
              key: i.machineSeriesID,
              label: i.model + " " + i.version,
              model : i.model
            };
            this.seriesData.push(obj);
          });
          resolve("getSeriesList done");
        });
      });
    },

    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      if (!this.isSearched) {
        this.getFileList();
        // this.getConditionList();
      } else {
        this.handleSearchList();
      }
    },

    /**
     * @description: 重置搜索表单
     * @return {*}
     */
    handleResetSearch() {
      this.clearQueryCondition();
      this.handleSearchList();
    },

    /**
     * 清空查询条件
     */
    clearQueryCondition(){
      this.listQuery.areaType="";
      this.listQuery.csFileTypeId="";
      this.listQuery.fileType="";
      this.listQuery.seriesType="";
      this.listQuery.condition={};
      this.listQuery.conditionVal={};
      this.currentPage=1;
    },

    /**
     * 初始跳转到此页面，获取产品资料列表
     */
    getFileList(){
      let conditionsList=[];
      if (this.activeName !== "-1" && this.activeName !== "-2") { //-2 这个案件用来控制对话框，-1这个空间无明确分类
        conditionsList.push({field: "dataType", op: "equal", value: this.activeName.toString()});
      }//分类
      let params = {
        type:0,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      if(conditionsList.length){
        params.where=conditionsList;
      }
      getFileByCondition(params).then((res) => {
        this.fileList = res.data.rows;
        this.totalCount = res.data.total;
      });
    },
    /**
     * @description: 筛选查询
     * @param {*}
     * @return {*}
     */
    handleSearchList() {
      // 保存输入的类别数据
      this.isSearched = true; //切换为人工搜索状态
      const listQuery = this.listQuery;
      const activeName =this.activeName;
      let conditionsList = [];
      //分类
      if(activeName!=="-1"){
        conditionsList.push({field:"dataType",op:"equal",value:activeName.toString()});
      }
      //文件格式
      if(listQuery.fileType!==''){
        conditionsList.push({field:"fileSuffix",op:"equal",value:listQuery.fileType.toString()});
      }
      //筛选条件
      if (listQuery.conditionVal.fieldName && listQuery.conditionVal.fieldOp && listQuery.conditionVal.fieldValue) {
        conditionsList.push({field: listQuery.conditionVal.fieldName, op: listQuery.conditionVal.fieldOp, value: listQuery.conditionVal.fieldValue,});//
      }

        // 初始化请求参数
      let params = {
        type:0,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if(listQuery.keyword!==""){
        params.keyWord=listQuery.keyword;
      }
      if(conditionsList.length>0){
        params.where=conditionsList;
      }
      // 发起请求
      getFileByCondition(params).then((res)=>{
        console.log(res);
        this.fileList = res.data.rows;
        this.totalCount = res.data.total;
      });
    },

    // 筛选条件改动
    onConditionChange(e) {
      this.conditionValOptions = e.childConditionList;
    },

    //筛选条件具体值改动
    onConditionValueChange(e){
      console.log("eeeee");
      console.log(e);
      // this.listQuery.fileType=e;
      this.currentPage=1;
      this.handleSearchList();
    },

    //取消添加分类对话框
    cancelAddCondition(){
      this.conditionDialogVisible = false;
      this.showSelectionClass=false;
      this.clearQueryCondition();
      this.activeName="-1";
      this.getFileList();
    },

    /**
     * 文件置顶设置
     * @param csFileID 文件id
     * @param e true/false
     */
    onTopStatusChange(csFileID,e){
        let params={
          csFileID:csFileID,
          topStatus:e?1:0,
        };
        topStatusFile(params).then((res)=>{
          console.log(res);
        });
    },

    onFileTypeChange(e){
      this.listQuery.fileType=e;
      this.currentPage=1;
      this.handleSearchList();
    },

    onDataTypeChange(e){
      this.listQuery.dataType=e;
      this.currentPage=1;
      this.handleSearchList();
    },

    onSeriesTypeChange(e){
      this.listQuery.seriesType=e;
      this.currentPage=1;
      this.handleSearchList();
    },

    onAreaTypeChange(e){
      this.listQuery.areaType=e;
      this.currentPage=1;
      this.handleSearchList();
    },
    changeCellStyleExpand(row, column, rowIndex, columnIndex) {
      if (row.column.label === "属性") {
        return "background: #F2F6FC;"; // 修改的样式
      } else {
        return "";
      }
      },
  }
};
</script> 


<style lang="scss" scoped>
.toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  .tag-select {
    width: 200px;
    margin-right: 20px;
    .el-input {
      width: 200px;
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.demo-table-expand {
       font-size: 0;
       .el-form-item {
         margin-right: 0;
         margin-bottom: 0;
         width: 100%;
         ::v-deep .el-form-item__label {
             width: 120px;
             color: #99a9bf;
         }
       }
}

.el-dropdown-link {
    cursor: pointer;
}
.el-icon-s-operation {
    font-size: 24px;
}
.demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
}

.el-table__body tr.current-row > td {
    background-color: #add8e6 !important;
    // color: coral; /* 设置文字颜色，可以选择不设置 */
}

</style>
